<template>
	<div v-if="toggle == 'on'" id="livestream" :class="location === 'Radical Broadcast' || location === 'Full Screen' ? 'also-in-rb' : 'draggable'">
		<iframe :src="embed" width="360" height="270" frameborder="0" allowfullscreen style="pointer-events:all;min-width:100%;min-height:100%;"></iframe>
 	</div>
</template>


<script>
import interact from 'interactjs'

export default {
  name: 'Livestream',
  data () {
	  return {
		  toggle: '',
		  id: '',
      location: ''
	  };
  },
  methods: {
	  getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
			  	this.toggle = document.data.livestream
			  	this.id = document.data.livestream_id,
          this.location = document.data.livestreamlocation
		  	})
	  }
  },
  created () {
	  this.getContent();
  },
  mounted () {
  },
  computed: {
	  embed () {
		  return 'https://player.vimeo.com/video/' + this.id
	  }
  },
  watch: {
  }
}

interact('.draggable')
  .draggable({
    inertia: true,
    // keep the element within the area of it's parent
    // enable autoScroll
    autoScroll: true,

    // call this function on every dragmove event
    onmove: dragMoveListener
   });

  function dragMoveListener (event) {
    var target = event.target,
        // keep the dragged position in the data-x/data-y attributes
        x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
        y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    // translate the element
    target.style.webkitTransform =
    target.style.transform =
      'translate(' + x + 'px, ' + y + 'px)';

    // update the posiion attributes
    target.setAttribute('data-x', x);
    target.setAttribute('data-y', y);
  }

  // this is used later in the resizing and gesture demos
  window.dragMoveListener = dragMoveListener;
  
</script>